import { z } from "zod/v4";
import { emptySchema } from "@libs/schema/Empty.js";
import type { Schema } from "@libs/schema/Schema.js";

export const clientConfigSchema = z
	.object({
		awsRegion: z.string(),
		cognitoClientId: z.string(),
		cognitoDomain: z.string().nullable(),
		cognitoEndpoint: z.string().nullable(),
		cognitoIdentityPoolId: z.string(),
		cognitoUserPoolId: z.string(),
	})
	.strict();

export type ClientConfig = z.infer<typeof clientConfigSchema>;

export const clientConfig = {
	"/client-config": {
		openapi: {
			tags: ["config"],
		},
		params: emptySchema,
		GET: {
			query: emptySchema,
			response: clientConfigSchema,
			errors: [],
		},
	},
} satisfies Schema;
